import * as React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './Components/Landing';
import Eligibility from './Components/Eligibility';
import Allotment from './Components/Allotment';
import Courses from './Components/Courses';
import Comparison from './Components/Comparison';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
  // Define your theme options here if needed
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
    <Router>
      <Landing/>
 <Routes>
        <Route path="/" element={<Eligibility />} />
      </Routes>      
     </Router>
     </ThemeProvider>
  );
}
